import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { visibleTracksSelector } from '../../features/datacenter/historySlice';
import { mapServiceSelector, mapControlSelector, gensetTrackReportIdSelector } from '../../features/map/mapSlice';

import GoogleTrackLine from './google/GoogleTrackLine';
import OsmTrackLine from './osm/OsmTrackLine';

const TracksOverlay = ({ map }) => {
    const visibleTracks = useSelector(visibleTracksSelector);
    const mapService = useSelector(mapServiceSelector);
    const mapControl = useSelector(mapControlSelector);
    const gensetTrackReportId = useSelector(gensetTrackReportIdSelector);
    const plotTracks = useCallback(
        () => {
            return visibleTracks.map(reportID =>
                mapService === 'google' ?
                    <GoogleTrackLine
                        key={reportID}
                        reportID={reportID}
                    />
                    :
                    <OsmTrackLine
                        key={reportID}
                        reportID={reportID}
                    />

            );
        },
        [visibleTracks, mapService],
    )
    if (mapControl === 'track' && gensetTrackReportId) {
        return null;
    }
    return (
        <div>{plotTracks()}</div>
    );
}

export default TracksOverlay;
